import * as yup from 'yup';
import type { FormInputProps } from '@gov-nx/ui/types';
import type { InputDefinition } from './string';
import { useInputDefinition } from './string';

interface AddressSearchShape {
	controls: boolean;
	nazevObce: {
		requiredMessage: string;
	};
	cislo: {
		requiredMessage: string;
		max9999Message: string;
		onlyNumbersMessage: string;
	};
}

/**
 * @deprecated use useAddressSearchDefinition instead
 */

export const useAddressSearchShape = () => ({
	getAddressSearchDefaultValues: () => ({
		nazevObce: undefined,
		nazevUlice: undefined,
		cislo: undefined,
	}),
	getAddressSearchShape: ({
		controls,
		nazevObce,
		cislo,
	}: AddressSearchShape) => ({
		nazevObce: yup.string().when([], () => {
			if (controls) {
				return yup.string().required(nazevObce.requiredMessage);
			}
			return yup.string().optional();
		}),
		nazevUlice: yup.string().optional(),
		cislo: yup.string().when([], () => {
			if (controls) {
				return yup
					.string()
					.required(cislo.requiredMessage)
					.min(0)
					.max(4, cislo.max9999Message)
					.matches(/^[0-9]+$/, cislo.onlyNumbersMessage);
			}
			return yup.string().optional();
		}),
	}),
});

export type AddressSearchFormData = {
	nazevObce?: string;
	nazevUlice?: string;
	cislo?: string;
};

export type AddressSearchFormFields = {
	nazevObce: FormInputProps;
	nazevUlice: FormInputProps;
	cislo: FormInputProps;
};

export type AddressSearchDefinition = [
	InputDefinition,
	InputDefinition,
	InputDefinition,
];

export const useAddressSearchDefinition = ({
	isDisabled,
	isSearchShown,
	strings,
}: {
	isDisabled: boolean;
	isSearchShown: boolean;
	strings: {
		nazevObce: { label: string; placeholder: string; requiredMessage: string };
		nazevUlice: { label: string; placeholder: string };
		cislo: {
			label: string;
			placeholder: string;
			requiredMessage: string;
			max9999Message: string;
			onlyNumbersMessage: string;
		};
	};
}): AddressSearchDefinition => {
	const nazevObce = useInputDefinition({
		name: 'nazevObce',
		label: strings.nazevObce.label,
		isDisabled,
		placeholder: strings.nazevObce.placeholder,
		isRequired: isSearchShown,
	});
	const nazevUlice = useInputDefinition({
		name: 'nazevUlice',
		label: strings.nazevUlice.label,
		isDisabled,
		placeholder: strings.nazevUlice.placeholder,
	});
	const cislo = useInputDefinition({
		name: 'cislo',
		label: strings.cislo.label,
		isDisabled,
		placeholder: strings.cislo.placeholder,
		max: { max: 4, errorMessage: strings.cislo.max9999Message },
		onlyNumbers: { errorMessage: strings.cislo.onlyNumbersMessage },
		isRequired: isSearchShown,
	});

	return [nazevObce, nazevUlice, cislo];
};
